import { Text } from '@genial/components';
import { Utils } from '@genial/utils';
import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { cohortCellGapHorizontal, cohortCellHeight } from '../../constants';
import { CohortCell, CohortCellTypes } from '../CohortCell';
import { CohortCellSpacer } from '../CohortCellSpacer';

export namespace CohortRowTypes {
  export type Props = {
    monthName: string;
    endPercentage: number;
    monthValues: CohortCellTypes.Props[];
    cellsPerRow: number;
  };
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    gap: cohortCellGapHorizontal,
    justifyContent: 'center',
    height: cohortCellHeight,
  },
});

export const CohortRow: React.FC<CohortRowTypes.Props> = ({
  endPercentage,
  monthName,
  monthValues,
  cellsPerRow,
}) => {
  const numSpaces = cellsPerRow - monthValues.length;
  const spacer = useMemo(
    () =>
      numSpaces > 0
        ? Array(numSpaces)
            .fill(undefined)
            .map((_, index) => <CohortCellSpacer key={index.toString()} />)
        : null,
    [numSpaces]
  );

  const cells = useMemo(
    () => monthValues.map((item, index) => <CohortCell key={index} {...item} />),
    [monthValues]
  );

  return (
    <View style={styles.container}>
      <Text flex={1} alignItems="center" display="flex">
        {monthName}
      </Text>
      {cells}
      {spacer}
      <Text flex={1} alignItems="center" display="flex">
        {Utils.Mask.Percentage(endPercentage)}
      </Text>
    </View>
  );
};
